import { Location } from "react-router";
import { FEATURES, ROUTES } from "./navigation";

/**
 * Determines whether the current location corresponds to a page that should be included in test drive section.
 * @param location The location object from React Router.
 * @returns A boolean value indicating whether the current location corresponds to a test drive section.
 */
export const getTestDriveSection = (location: Location) => {
  const testDrivePages = [
    ROUTES.home,
    ROUTES.solutions,
    ROUTES.industries,
    ROUTES.whyTrackmate,
    `${ROUTES.features}/${FEATURES.telematics}`,
    `${ROUTES.features}/${FEATURES.compliance}`,
    `${ROUTES.features}/${FEATURES.alerts}`,
    `${ROUTES.features}/${FEATURES.reports}`,
    ROUTES.helpCenter,
  ];

  return testDrivePages.some((route) => route === location.pathname) ||
    location.pathname.includes(ROUTES.industries);
}
